import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import {
  selectCompanyMargins,
  selectCompanyMarginsError,
  selectCompanyMarginsIsLoading,
  selectCompanyMarginsIsSaving,
  selectCompanyMarginsSaveError,
} from '../selectors/company-margins.selectors';

@Injectable({ providedIn: 'root' })
export class CompanyMarginsSelectorsFacade {
  private readonly _store = inject(Store);

  public readonly margins = this._store.selectSignal(selectCompanyMargins);
  public readonly isLoading = this._store.selectSignal(
    selectCompanyMarginsIsLoading,
  );
  public readonly error = this._store.selectSignal(selectCompanyMarginsError);
  public readonly isSaving = this._store.selectSignal(
    selectCompanyMarginsIsSaving,
  );
  public readonly saveError = this._store.selectSignal(
    selectCompanyMarginsSaveError,
  );
}
